export const ROLE_LABEL = {
  super_admin: "Super Admin",
  manager: "Sales Head / Manager",
  field_executive: "Field Sales Executive",
  sales_partner: "Sales Partner",
  telecaller: "Telecaller",
  finance_manager: "Finance / Commission Manager",
};

export const STATUS_COLORS = {
  // leads (14 standard statuses)
  New: "bg-sky-50 text-sky-700 border-sky-200",
  Contacted: "bg-amber-50 text-amber-700 border-amber-200",
  Interested: "bg-teal-50 text-teal-700 border-teal-200",
  "Follow-up Due": "bg-orange-50 text-orange-700 border-orange-200",
  "Meeting Scheduled": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Demo Scheduled": "bg-violet-50 text-violet-700 border-violet-200",
  "Demo Completed": "bg-purple-50 text-purple-700 border-purple-200",
  "Proposal Sent": "bg-cyan-50 text-cyan-700 border-cyan-200",
  Negotiation: "bg-yellow-50 text-yellow-800 border-yellow-200",
  "Nurture Later": "bg-slate-100 text-slate-600 border-slate-200",
  "Not Interested": "bg-rose-50 text-rose-600 border-rose-200",
  "Wrong Contact": "bg-stone-100 text-stone-600 border-stone-200",
  stale: "bg-amber-50 text-amber-700 border-amber-300",
  Qualified: "bg-violet-50 text-violet-700 border-violet-200",
  Converted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Merged: "bg-slate-100 text-slate-500 border-slate-200",
  lost: "bg-rose-50 text-rose-700 border-rose-200",
  Lost: "bg-rose-50 text-rose-700 border-rose-200",
  open: "bg-sky-50 text-sky-700 border-sky-200",
  // duplicate
  exact: "bg-rose-50 text-rose-700 border-rose-200",
  possible: "bg-amber-50 text-amber-700 border-amber-200",
  none: "bg-emerald-50 text-emerald-700 border-emerald-200",
  // work
  working: "bg-emerald-50 text-emerald-700 border-emerald-200",
  ended: "bg-slate-100 text-slate-600 border-slate-200",
  // commission
  "Pending Payment Verification": "bg-amber-50 text-amber-700 border-amber-200",
  "Payment Verified": "bg-sky-50 text-sky-700 border-sky-200",
  "Commission Calculated": "bg-sky-50 text-sky-700 border-sky-200",
  "Awaiting Approval": "bg-amber-50 text-amber-700 border-amber-200",
  Approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Scheduled for Payout": "bg-violet-50 text-violet-700 border-violet-200",
  Paid: "bg-emerald-100 text-emerald-800 border-emerald-300",
  Reversed: "bg-rose-50 text-rose-700 border-rose-200",
};

export function statusClass(status) {
  return STATUS_COLORS[status] || "bg-slate-100 text-slate-700 border-slate-200";
}
